export default __webpack_public_path__ + "static/media/dashboard-cassa.3ab285d8.png";